"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const heartstyled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 49 42",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-heartstyled` : '') + (description ? ` desc-heartstyled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-heartstyled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-heartstyled"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "Icons",
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-661.000000, -1929.000000) translate(662.000000, 1930.000000)",
    id: "HeartStyled_icon"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "streamline-icon-love-it@140x140",
    transform: "translate(3.000000, 3.000000)",
    fill: "#FFCCD8"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.5008845,38 L3.32587765,18.6973751 C-0.130358908,15.3641038 -0.986892889,10.269296 1.19998775,6.05222554 L1.19998775,6.05222554 C2.83116045,2.90437704 5.93056143,0.705143704 9.53006668,0.141474602 C13.1295719,-0.422194498 16.7903949,0.71841296 19.3690467,3.20701863 L22.5008845,6.22787941 L25.6327223,3.20701863 C28.2113742,0.71841296 31.8721972,-0.422194498 35.4717024,0.141474602 C39.0712076,0.705143704 42.1706086,2.90437704 43.8017813,6.05222554 L43.8017813,6.05222554 C45.9856015,10.2675002 45.1301087,15.3585737 41.6778913,18.6915843 L22.5008845,38 Z",
    id: "Path"
  })), /*#__PURE__*/_react.default.createElement("g", {
    id: "streamline-icon-love-it@140x140",
    stroke: "#F26B1C"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.5008845,38 L3.32587765,18.6973751 C-0.130358908,15.3641038 -0.986892889,10.269296 1.19998775,6.05222554 L1.19998775,6.05222554 C2.83116045,2.90437704 5.93056143,0.705143704 9.53006668,0.141474602 C13.1295719,-0.422194498 16.7903949,0.71841296 19.3690467,3.20701863 L22.5008845,6.22787941 L25.6327223,3.20701863 C28.2113742,0.71841296 31.8721972,-0.422194498 35.4717024,0.141474602 C39.0712076,0.705143704 42.1706086,2.90437704 43.8017813,6.05222554 L43.8017813,6.05222554 C45.9856015,10.2675002 45.1301087,15.3585737 41.6778913,18.6915843 L22.5008845,38 Z",
    id: "Path"
  })))));
};
var _default = exports.default = heartstyled;